(function() {
  // Debug configuration
  const DEBUG = {
    enabled: false,
    prefix: '🔍 Recent Items:'
  };

  function debugLog(...args) {
    if (!DEBUG.enabled) return;
    console.log(DEBUG.prefix, ...args);
  }


  document.addEventListener('click', function (event) {
      const isInsideSearchBox = event.target.closest('.algolia-search-box');
      const isInsideHeader = event.target.closest('.site-nav-search-area');
      const isInsidePanel = event.target.closest('.aa-Panel');

      if (!isInsideHeader && !isInsidePanel && !isInsideSearchBox) {
        document.body.classList.remove('__show-form-on-sticky-header');
      }
  });
  
  // Constants for storage
  const RECENT_SEARCHES_KEY = 'algolia_recent_searches';
  const RECENT_VIEWED_KEY = 'algolia_recent_viewed';
  const MAX_ITEMS = 8;  // Updated to 6 items

  // Create storage plugin for recent searches
  const storage = {
    getItem(key) {
      try {
        const items = JSON.parse(localStorage.getItem(key) || '[]');
        debugLog('Retrieved from storage:', { key, items });
        return items;
      } catch (error) {
        debugLog('Error retrieving from storage:', { key, error });
        return [];
      }
    },
    setItem(key, value) {
      try {
        localStorage.setItem(key, JSON.stringify(value));
        debugLog('Saved to storage:', { key, value });
      } catch (error) {
        debugLog('Error saving to storage:', { key, error });
      }
    },
    removeItem(key) {
      try {
        localStorage.removeItem(key);
        debugLog('Removed from storage:', { key });
      } catch (error) {
        debugLog('Error removing from storage:', { key, error });
      }
    }
  };

  // Create recent searches plugin
  const recentSearchesPlugin = {
    name: 'aa-recent-searches',
    getSources({ query, setQuery }) {
      if (query) return [];

      const searches = storage.getItem(RECENT_SEARCHES_KEY) || [];
      if (!searches.length) return [];

      return [{
        sourceId: 'recentSearches',
        getItems() {
          return searches.map(query => ({
            query,
            label: query
          }));
        },
        onSelect({ item }) {
          window.location.href = `${window.Shopify.routes.root}search?q=${encodeURIComponent(item.query)}`;
        },
        templates: {
          header({ html }) {
            return html`
                <span class="aa-SourceHeaderTitle">Recent Searches</span>
                  <div class="aa-Button aa-Button--clear" data-clear-searches>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M5.07725 13.3333C4.77859 13.3333 4.52436 13.2285 4.31459 13.0187C4.10481 12.8089 3.99992 12.5549 3.99992 12.2567V4.00001H3.33325V3.33334H5.99992V2.82001H9.99992V3.33334H12.6666V4.00001H11.9999V12.2567C11.9999 12.5633 11.8973 12.8196 11.6919 13.0253C11.4866 13.2311 11.2301 13.3338 10.9226 13.3333H5.07725ZM11.3333 4.00001H4.66659V12.2567C4.66659 12.3762 4.70503 12.4745 4.78192 12.5513C4.85881 12.6282 4.95725 12.6667 5.07725 12.6667H10.9233C11.0255 12.6667 11.1195 12.624 11.2053 12.5387C11.291 12.4533 11.3337 12.3591 11.3333 12.256V4.00001ZM6.53858 11.3333H7.20525V5.33334H6.53858V11.3333ZM8.79459 11.3333H9.46125V5.33334H8.79459V11.3333Z" fill="#557377"/>
                    </svg>
                    <span>Clear</span>
                  </div>
                <div class="aa-SourceHeaderLine">
                </div>
            `;
          },
          item({ item, html }) {
            return html`
              <div class="aa-ItemWrapper">
                <div class="aa-ItemContent">
                  <div class="aa-ItemIcon aa-ItemIcon--noBorder">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M13.5 13.5L10.485 10.5M11.79 7.145C11.79 8.06369 11.5176 8.96176 11.0072 9.72562C10.4968 10.4895 9.77133 11.0849 8.92257 11.4364C8.0738 11.788 7.13985 11.88 6.23881 11.7007C5.33777 11.5215 4.51011 11.0791 3.86049 10.4295C3.21088 9.7799 2.76848 8.95224 2.58925 8.05119C2.41003 7.15015 2.50201 6.2162 2.85358 5.36744C3.20515 4.51867 3.80051 3.79322 4.56438 3.28282C5.32825 2.77242 6.22631 2.5 7.145 2.5C7.75499 2.5 8.35901 2.62015 8.92257 2.85358C9.48612 3.08701 9.99819 3.42916 10.4295 3.86049C10.8608 4.29182 11.203 4.80388 11.4364 5.36744C11.6699 5.93099 11.79 6.53501 11.79 7.145V7.145Z" stroke="#B4B4B4" style="stroke:#B4B4B4;stroke:color(display-p3 0.7078 0.7078 0.7078);stroke-opacity:1;" stroke-miterlimit="10"/>
                    </svg>
                  </div>
                  <div class="aa-ItemContentBody">
                    <div class="aa-ItemContentTitle">${item.label}</div>
                  </div>
                </div>
              </div>
            `;
          }
        }
      }];
    }
  };

  // Create recently viewed plugin
  const recentlyViewedPlugin = {
    name: 'aa-recently-viewed',
    getSources({ query }) {
      if (query) return [];

      const viewed = storage.getItem(RECENT_VIEWED_KEY) || [];
      if (!viewed.length) return [];

      return [{
        sourceId: 'recentlyViewed',
        getItems() {
          return viewed;
        },
        onSelect({ item }) {
          window.location.href = item.url;
        },
        onClick({ item }) {
          window.location.href = item.url;
        },
        templates: {
          header({ html }) {
            return html`
                <span class="aa-SourceHeaderTitle">Recently Viewed</span>
                <div class="aa-SourceHeaderLine"></div>
            `;
          },
          item({ item, html }) {
            return html`
              <div class="aa-ItemWrapper">
                <a href="${item.url}" class="aa-ItemLink">
                  <div class="aa-ItemContent">
                    <div class="aa-ItemPicture aa-ItemPicture--loaded">
                      <img src="${item.image}" alt="${item.title}"/>
                    </div>
                    <div class="aa-ItemContentBody">
                      <div class="aa-ItemContentTitle">${item.title}</div>
                      ${item.price ? html`<div class="aa-ItemContentPrice">${item.price}</div>` : ''}
                    </div>
                  </div>
                </a>
              </div>
            `;
          }
        }
      }];
    }
  };

  // Register Hooks when Algolia is ready
  document.addEventListener('algolia.hooks.initialize', function() {
    const algolia = window.algoliaShopify;

    // Add event delegation for clear button
    document.addEventListener('click', function(e) {
      const clearButton = e.target.closest('[data-clear-searches]');
      if (clearButton) {
        e.preventDefault();
        e.stopPropagation();
        storage.removeItem(RECENT_SEARCHES_KEY);
        document.querySelector('.aa-Panel').remove();
        document.querySelector('.aa-Input').blur();
        algolia.autocomplete.setIsOpen(false);
        debugLog('Cleared recent searches');
      }
    }, true);

    // Track product views on product pages
    if (window.location.pathname.includes('/products/')) {
      const productJSON = document.getElementById('ProductJSON');
      if (productJSON) {
        try {
          const product = JSON.parse(productJSON.textContent);
          const originalImage = product.featured_image || product.images[0];
          const smallImage = originalImage.replace(/\.(jpg|jpeg|png|gif|webp)/i, '_250x250.$1');
          
          const productData = {
            objectID: product.id,
            title: product.title,
            url: window.location.href,
            image: smallImage,
            price: product.price_formatted || window.theme.Currency.formatMoney(product.price),
            vendor: product.vendor,
            handle: product.handle
          };

          debugLog('Tracking product page view:', {
            id: productData.objectID,
            title: productData.title
          });

          const viewed = storage.getItem(RECENT_VIEWED_KEY) || [];
          const newViewed = [productData, ...viewed.filter(p => p.objectID !== productData.objectID)]
            .slice(0, MAX_ITEMS);
          storage.setItem(RECENT_VIEWED_KEY, newViewed);
        } catch (error) {
          debugLog('Error tracking product page view:', error);
        }
      }
    }

    // Hook for template layout
    algolia.hooks.registerHook('beforeAutocompleteMainTemplate', function(defaultTemplate, templateOptions, elements) {
      const { html, state } = templateOptions;
      
      // Base panel layout with loading state
      const panelLayout = html`
        <div class="aa-PanelLayout aa-Panel--scrollable" style="display: ${state.isOpen ? 'block' : 'none'}">
          <div class="aa-PanelSections ${!elements ? 'aa-Panel--loading' : ''}">
            ${!elements ? html`<div class="aa-LoadingIndicator">Loading...</div>` : html`
              ${!state.query || state.query.length < 3 ? html`
                <div class="aa-PanelSection--left">
                  ${elements.recentSearches}
                </div>
                <div class="aa-PanelSection--right">
                  ${elements.recentlyViewed}
                </div>
              ` : html`
                <div class="aa-PanelSection--left">
                  <div class="aa-SourceHeader">
                    <span class="aa-SourceHeaderTitle">Search suggestions</span>
                    <div class="aa-SourceHeaderLine"></div>
                  </div>
                  ${elements.querySuggestionsPlugin}
                  ${elements.collections}
                  ${elements.articles}
                  ${elements.pages}
                  ${elements.redirectUrlPlugin}
                </div>
                <div class="aa-PanelSection--right">
                  ${elements.products}
                  ${state.query ? html`
                <div class="aa-ViewAll">
                  <a href="${window.Shopify.routes.root}search?q=${encodeURIComponent(state.query)}" class="aa-ViewAllButton">
                    View all <span>"${state.query}"</span>
                  </a>
                </div>
              ` : ''}
                </div>
              `}
            `}
          </div>
        </div>
      `;

      return panelLayout;
    });

    // Add click event handler for clear button
    document.addEventListener('click', function(event) {
      if (event.target.closest('[data-action="clear-searches"]')) {
        storage.removeItem(RECENT_SEARCHES_KEY);
        debugLog('Cleared recent searches');
        
        const viewed = storage.getItem(RECENT_VIEWED_KEY) || [];
        if (!viewed.length) {
          algolia.autocomplete.setIsOpen(false);
        } else {
          algolia.autocomplete.refresh();
        }
      }
    });
    
    algolia.hooks.registerHook('beforeAutocompleteNoResultsTemplate', function(defaultTemplate, templateData) {
      const { state } = templateData;
      
      // Return null template if query is empty
      if (!state.query) {
        return null;
      }
      
      return defaultTemplate;
    });
    const redirectPlugin = {
      name: 'aa.redirectPlugin',
      getSources({ query }) {
        if (!query || query.length < 3) return [];
        return [{
          sourceId: 'redirects',
          getItems() {
            return window.algoliaShopify.searchClient
              .initIndex('shopify_redirects')
              .search(query, {
                hitsPerPage: 1,
                facetFilters: ['searchTerm'], // Keep this to filter valid redirect records
                attributesToRetrieve: ['redirectUrl', 'searchTerm']
              })
              .then(({ hits }) => {
                if (hits.length > 0 && hits[0].redirectUrl && hits[0].searchTerm) {
                  const exactMatch = hits[0].searchTerm.toLowerCase() === query.toLowerCase();
                  if (exactMatch) {
                    return [{
                      redirect: {
                        url: hits[0].redirectUrl,
                        query: hits[0].searchTerm
                      }
                    }];
                  }
                }
                return [];
              })
              .catch(() => []);
          },
          onSelect({ item }) {
            if (item.redirect) {
              window.location.href = item.redirect.url;
            }
          },
          templates: {
            item({ item, html }) {
              if (!item.redirect) return null;
              return html`
                <div class="aa-ItemWrapper">
                  <div class="aa-ItemContent">
                    <div class="aa-ItemContentBody">
                      <div class="aa-ItemContentTitle">Press Enter to go to: ${item.redirect.query}</div>
                    </div>
                  </div>
                </div>
              `;
            }
          }
        }];
      }
    };
    // Modify the productsPlugin to check query length
    // algolia.hooks.registerHook('beforeAutocompleteFiltersString', function(filters, context) {
    //   // Get query from the context instead of autocomplete state
    //   const query = context?.query;
    //   if (!query || query.length < 3) {
    //     return 'objectID:-1'; // Return filter that matches nothing
    //   }
    //   return filters;
    // });
    // Hook for options
    // algolia.hooks.registerHook('beforeInstantSearchOptions', function(options) {
    //   console.log(options);
    // })
    
    /*
    algolia.hooks.registerHook('beforeInstantSearchConfigurationOptions', (options) => {
      const originalSearchFunction = options.searchFunction;
      options.searchFunction = (helper) => {
        const minChars = 3; // Set minimum characters required
        const query = helper.state.query || '';
        if (query.length && query.length >= minChars) {
          originalSearchFunction(helper);
        }
      };
      return options;
    });
    */
    
    algolia.hooks.registerHook('beforeAutocompleteOptions', function(options) {
      const searches = storage.getItem(RECENT_SEARCHES_KEY) || [];
      const viewed = storage.getItem(RECENT_VIEWED_KEY) || [];
      const originalPlugins = options.plugins || [];
      const customPlugins = originalPlugins.map(plugin => {
        // Skip plugins without getSources
        if (!plugin.getSources) {
          return plugin;
        }

        const originalGetSources = plugin.getSources;
        debugLog(originalGetSources);
        // Handle query suggestions plugin differently
        if (plugin.name === 'aa.querySuggestionsPlugin') {
          return {
            ...plugin,
            getSources: (params) => {
              if (!params?.query || params.query.length < 3) {
                return [{
                  sourceId: 'querySuggestionsPlugin',
                  getItemInputValue: function(params) {
                    return params.item.query;
                  },
                  getItems: function() {
                    return Promise.resolve([]);
                  },
                  items: [],
                  templates: {
                    header({ html }) {
                      return html`
                        <div class="aa-SourceHeader">
                          <span class="aa-SourceHeaderTitle">Search suggestions</span>
                          <div class="aa-SourceHeaderLine"></div>
                        </div>
                      `;
                    },
                    item({ item, html }) {
                      return html`
                        <div class="aa-ItemWrapper">
                          <div class="aa-ItemContent">
                            <div class="aa-ItemContentBody">
                              <div class="aa-ItemContentTitle">${item.query}</div>
                            </div>
                          </div>
                        </div>
                      `;
                    }
                  }
                }];
              }
              return originalGetSources(params);
            }
          };
        }
        
        // Handle other plugins with getSources
        return {
          ...plugin,
          getSources: ({query:o, setContext:c}) => {
            if (!o || o.length < 3) {
              return [];
            }
            return originalGetSources({query:o, setContext:c});
          }
        };
      });
      options.plugins = customPlugins;
      return {
        ...options,
        openOnFocus: (searches.length > 0 || viewed.length > 0) ? true : false,
        minLength: 3,
        shouldPanelOpen: ({ state }) => {
          debugLog(state);
          if (!state.query) {
            // return state.isOpen && (searches.length > 0 || viewed.length > 0);
          }
          // Hide panel if query length is less than 3
          if (state.query.length > 0 && state.query.length < 3) {
            return false;
          }
          return state;
        },
         searchFunction(helper) {
            if (helper.state.query) {
              const search_string = helper.state.query;
          
              if (search_string.length < 3) {
                return false;
              }
              // Will only trigger when more than three characters have been typed
              helper.search();
            }
        },
        placeholder: 'What we can help you find?',
        plugins: [...(options.plugins || []), recentSearchesPlugin, recentlyViewedPlugin],
        onSubmit({ state }) {
          if (state.query) {
            // Check for redirect first
            window.algoliaShopify.searchClient
              .initIndex('shopify_redirects')
              .search(state.query, {
                hitsPerPage: 1,
                facetFilters: ['searchTerm'], // Keep this to filter valid redirect records
                attributesToRetrieve: ['redirectUrl', 'searchTerm']
              })
              .then(({ hits }) => {
                if (hits.length > 0 && hits[0].redirectUrl && hits[0].searchTerm) {
                  const exactMatch = hits[0].searchTerm.toLowerCase() === state.query.toLowerCase();
                  if (exactMatch) {
                    window.location.href = hits[0].redirectUrl;
                    return;
                  }
                }
                // No redirect found, proceed with default search
                debugLog('Tracking submitted search:', state.query);
                const searches = storage.getItem(RECENT_SEARCHES_KEY) || [];
                const newSearches = [state.query, ...searches.filter(s => s !== state.query)]
                  .slice(0, MAX_ITEMS);
                storage.setItem(RECENT_SEARCHES_KEY, newSearches);
                window.location.href = `${window.Shopify.routes.root}search?q=${encodeURIComponent(state.query)}`;
              })
              .catch(() => {
                // On error, fall back to default search
                window.location.href = `${window.Shopify.routes.root}search?q=${encodeURIComponent(state.query)}`;
              });
          }
        }
      };
    });
    // Hook for tracking product views
    algolia.hooks.registerHook('afterAutocompleteProductClickAction', function(product) {
      if (!product) return product;

      const smallImage = product.image.replace(/\.(jpg|jpeg|png|gif|webp)/i, '_250x250.$1');
      
      const productData = {
        objectID: product.objectID,
        title: product.title,
        url: product.url,
        image: smallImage,
        price: product.price_formatted || window.theme.Currency.formatMoney(product.price),
        vendor: product.vendor,
        handle: product.handle
      };

      debugLog('Tracking product click:', {
        id: productData.objectID,
        title: productData.title
      });

      const viewed = storage.getItem(RECENT_VIEWED_KEY) || [];
      const newViewed = [productData, ...viewed.filter(p => p.objectID !== productData.objectID)]
        .slice(0, MAX_ITEMS);
      storage.setItem(RECENT_VIEWED_KEY, newViewed);

      return product;
    });

    debugLog('Recent items hooks initialized');
  });

  // Expose debug controls
  window.AlgoliaRecentItems = {
    debug: DEBUG,
    clearSearches: () => {
      storage.removeItem(RECENT_SEARCHES_KEY);
      debugLog('Cleared recent searches');
    },
    clearViewed: () => {
      storage.removeItem(RECENT_VIEWED_KEY);
      debugLog('Cleared recently viewed');
    },
    getSearches: () => storage.getItem(RECENT_SEARCHES_KEY),
    getViewed: () => storage.getItem(RECENT_VIEWED_KEY)
  };
})();

